import styled from "styled-components";

export const ErrorMsg = styled.p`
  color: ${({ theme }) => theme.white};
  background-color: ${({ theme }) => theme.red};
  font-size: 0.6rem;
  text-align: center;
  padding: 5px;
`;
